module.exports = __webpack_public_path__ + "static/media/pootsy-logo.c02e7251.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/pootsy-logo.png
// module id = 47
// module chunks = 0